import React from 'react';
import { motion } from 'framer-motion';
import MasonryGrid from '../components/MasonryGrid';
import { portfolioItems } from '../data/portfolioData';
const VideoPortfolio = () => {
  const videoItems = portfolioItems.filter(item => {
    if (Array.isArray(item.category)) {
      return item.category.includes('Video');
    }
    return item.category === 'Video';
  });
  return <motion.div className="p-6" initial={{
    opacity: 0,
    x: 100
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -100
  }} transition={{
    duration: 0.5,
    ease: 'easeInOut'
  }} data-id="element-358">
      <MasonryGrid items={videoItems} data-id="element-359" />
    </motion.div>;
};
export default VideoPortfolio;